import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Protected = ({ children }) => {
  const authInfo = useSelector((state) => state.auth)
  if (!authInfo?.isAuthenticated || !authInfo?.user) {
    return <Navigate to="/login" replace />
  }
  return children
}

export default Protected